import {h, Component} from "preact";
import Session from "../../utils/session";
import Admin from "../../../../services/admin";
import {LazyTree} from "../../utils/users-tree";
import {ActionButton, Cell, FiltersRow, HCell, HRow, InputRow, PaginationV2, Row, Table} from "../../utils/table-utils";
import { msg, t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import {PerPageFilter} from "../../utils/form-utils";
import MoneyFormatter from "../../utils/money-formatter";
import {openTopupPopup, TopupPopup} from "./manager-topup-popup";
import {UserTransactionPopup} from "./menu-dashboard";
import AwrabetManagerUserlist from "../../../awrabet/desktop-components/user/manager-userlist";

const TransactionIcon = (props) =>
    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="money-check-edit-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" class={props.class} style={(props.color ? 'color:'+props.color+';' : '')+props.style}>
        <path fill="currentColor" d="M204.78 116.47l4.1 4.1 71.69-71.8L238.78 7a24.1 24.1 0 0 0-33.9 0L167 44.87a24 24 0 0 0 0 33.8zM608 160H437l120.25 120.28A64 64 0 0 1 576 325.54V400a16 16 0 0 1-16 16H264a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h163l-64-64h-99a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h67L203 160H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM144 415.88V432a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8v-16.29a57.26 57.26 0 0 1-31.37-11.35 8 8 0 0 1-.57-12.14L91.81 381a8.21 8.21 0 0 1 10.13-.73 24.08 24.08 0 0 0 12.82 3.73h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V240a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16.29a57.18 57.18 0 0 1 31.37 11.35 8 8 0 0 1 .57 12.14L164.18 291a8.22 8.22 0 0 1-10.14.73 23.93 23.93 0 0 0-12.81-3.73h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.57 23.42 31.57 43.39 0 24.53-19.04 44.44-42.66 45.07zm318.87-41.25a32 32 0 0 0 22.62 9.37H528a16 16 0 0 0 16-16v-42.46a32 32 0 0 0-9.37-22.63L303.17 71.47l-71.7 71.7z" class=""></path>
    </svg>;

const TransactionsListIcon = (props) =>
    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="clipboard-list" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class={props.class} style={(props.color ? 'color:'+props.color+';' : '')+props.style}>
        <path fill="currentColor" d="M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z" class=""></path>
	</svg>;


export default class ManagerUserlist extends AwrabetManagerUserlist {
    render() {
        return <div class="flex flex-row">
            {!!this.state.structures.children && <div class="shrink-0 p-2 text-xs">
                <div class="bg-white border h-full p-3 relative">
                    <a
                        class="absolute p-1 rounded-r border border-l-0 bg-white text-gray-500 left-full top-10"
                        onClick={e => {
                            this.state.structures.collapseFilter = !this.state.structures.collapseFilter;
                            this.setState(!this.state);
                        }}
                        href="javascript:void(0);"
                    >
                        {this.state.structures.collapseFilter?
                            <i class="fa fa-caret-right" />
                            : <i class="fa fa-caret-left" />}
                    </a>
                    <div
                        class={"border-l-4 border-l-[#38b2ac] border flex-0 max-h-screen overflow-auto overflow-x-hidden bg-white min-h-full"+(this.state.structures.collapseFilter? ' w-px' : ' w-56')}
                    >
                        <LazyTree
                            data={this.state.structures.children}
                            loadChildren={(id, cb) => this.getManagerChildren(id, cb)}
                            onNodeSelected={structure => this.filterFromManagerChildren(structure)}
                            currentSelection={this.state.structures.filterid}
                            firstLevelOpen={true}
                        />
                    </div>
                </div>
            </div>}
            <div class="w-full">
                <FiltersRow class="p-2 text-sm items-end justify-center flex-wrap gap-1">
                    <InputRow
                        label={window.Translation(msg`User ID`)}
                        inputclass="w-full leading-6"
                        boxclass="w-40"
                        type="text"
                        onInput={e => {
                            this.state.page = 1;
                            this.state.input.lowlimit = 0;
                            this.state.input.idplayer = e.target.value.trim() === ''? null : e.target.value;
                            this.setState({});
                        }}
                        value={this.state.input.idplayer}
                    />
                    <InputRow
                        label={window.Translation(msg`User Name`)}
                        inputclass="w-full leading-6"
                        boxclass="w-40"
                        type="text"
                        onInput={e => {
                            this.state.page = 1;
                            this.state.input.lowlimit = 0;
                            this.state.input.username = e.target.value.trim() === ''? null : e.target.value;
                            this.setState({});
                        }}
                        value={this.state.input.username}
                    />
                    <PerPageFilter
                        perPage={this.state.input.searchRecordPerPage}
                        pageList={[10,30,45,50,100]}
                        onInput={
                            ({perPage}) => {
                                this.state.input.searchRecordPerPage = perPage;
                                this.setState(this.state);
                            }
                        }
                    />
                    <a
                        href="javascript:void(0);"
                        class="button p-2 ml-5 main-text-color"
                        onClick={e => this.performSearch()}
                    >
                        {!this.state.pageloading?
                            <Trans>Avvia Ricerca <i class="fa fa-search"/></Trans>
                            : <Trans>Ricerca In Corso... <i class="fa fa-spin fa-gear"/></Trans>}
                    </a>
                </FiltersRow>
                <div class="text-xs mt-3">

                    {!!this.state.response && <div class="block py-2 px-3 center bg-white border-t-2 mx-4">
                        <div class="py-4 mx-auto">
                            {!this.state.response.data.length && <div class="text-center text-lg text-gray-500">
                                <Trans>Non ci sono record da mostrare</Trans>
                            </div>}
                            {!!this.state.response.data.length && <Table>
                                <HRow>
                                    <HCell first={true}><Trans>User ID</Trans><br /><Trans>Registration Date</Trans></HCell>
                                    <HCell><Trans>Login</Trans><br /><Trans>Email</Trans></HCell>
                                    <HCell><Trans>Site</Trans><br /><Trans>Network</Trans></HCell>
                                    <HCell><Trans>Balances</Trans></HCell>
                                    <HCell action={true}><Trans>Actions</Trans></HCell>
                                </HRow>
                                {this.state.response.data.map((player, idx) => <UserRow key={idx} player={player} />)}
                            </Table>}
                        </div>
                        <PaginationV2
                            pages={this.state.totalpages}
                            currentPage={this.state.page}
                            onNavigation={page => {this.changePage(page, parseInt(page)*parseInt(this.state.input.searchRecordPerPage)-parseInt(this.state.input.searchRecordPerPage))}}
                            isLastPage={this.state.totalpages===this.state.page}
                        />
                    </div>}

                </div>
            </div>
        </div>;
    }
}

const UserRow = ({player}) => <Row class="border-b">
    <Cell class="p-1" first={true}>
        <a href="javascript:void(0)" class="block text-blue-500">
            <Trans>ID: <strong>{player.idcredenziale || player.idstruttura}</strong></Trans>
        </a>
        <span class="block">{!!player.created? player.created : '-'}</span>
    </Cell>
    <Cell class="p-1">
        <a href="javascript:void(0)" class="block text-green-500">{player.company}</a>
        <span class="block">{player.email}</span>
    </Cell>
    <Cell class="p-1">
        <span class="block">{player.skin}</span>
        <span class="block">{player.network}</span>
    </Cell>
    <Cell class="p-1 w-40 text-center">
        {player.account.map(wallet => <MoneyFormatter currency={wallet.currency} value={wallet.balance} />)}
    </Cell>
    <Cell class="p-1" action={true}>
        <ActionButton
            label="E"
            class="px-4 mr-1 font-bold inline"
            color="green"
            onClick={e => openTopupPopup(mapToStandard(player))}
        >
            <TransactionIcon class="w-5 relative inline-block -top-0.75" />
        </ActionButton>

        <ActionButton
            label="E"
            class="px-4 mr-1 font-bold inline"
            color="orange"
            onClick={e => UserTransactionPopup(player.company)}
        >
            <TransactionsListIcon class="w-5 relative inline-block h-5 -top-0.75" />
        </ActionButton>
    </Cell>
</Row>;

function mapToStandard(player) {
    return {
        id: player.idcredenziale || player.idstruttura,
        affiliate: player.type != 'player',
        shop: !!player.shop,
        parent: player.idparent
    }
}